<template>
	<div>
		<template v-for="index in parseInt(reportNum)">
			<v-layout class="mb-3" row wrap :key="index">
				<v-flex xs7>
					<v-subheader>Termin przekazania {{index}} raportu</v-subheader>
				</v-flex>
				<v-flex xs4>
					<egranty-date-picker
						label="Termin"
						for="volunteer-report-dates-date-report"
						id="volunteer-report-dates-date-report"
						v-model="dates[index - 1].reportDate"
						:disabled="disabled"
					></egranty-date-picker>
				</v-flex>
				<v-flex xs1/>
			</v-layout>
		</template>
	</div>
</template>

<script>
	import EgrantyDatePicker from "../../../genericComponents/EgrantyDatePicker";

	export default {
		name: "VolunteerReportDates",
		components: {EgrantyDatePicker},

		watch: {
			reportNumber (value) {
				if (value === '' || value < 0) return;
				this.reportNum = value;
				if (value > this.dates.length) {
					let index = this.dates.length;
					while (index < value) {
						this.dates.push(Object.assign({}, this.reportDateObject));
						this.dates[index].term = ++index;
					}
				}
				this.$emit("update-reports", this.reportNum, this.dates);
			}
		},

		methods: {
			getContestId() {
				return this.$route.params.id;
			},
		},

		data() {
			return {
				reportNum: undefined,

				dates: [],

				reportDateObject: {
					id: null,
					reportDate: null,
					term: null
				}
			};
		},

		created() {
			this.reportNum = this.reportNumber;
			this.dates = this.reportDates;
		},

		props: {
			value: Array,
			reportNumber: {},
			reportDates: {},
      disabled: {type: Boolean, default: false},
		},
	};
</script>

<style scoped>

</style>
